"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.renderIcon = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _FeIcon = _interopRequireDefault(require("./FeIcon"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var renderIcon = function renderIcon(_ref) {
  var icon = _ref.icon,
      iconFamily = _ref.iconFamily,
      iconPosition = _ref.iconPosition,
      children = _ref.children;
  var positionClass = iconPosition ? "fe-icon--".concat(iconPosition) : undefined;

  var feIcon = _react.default.createElement(_FeIcon.default, {
    key: "icon",
    family: iconFamily,
    icon: icon,
    className: positionClass
  });

  var output = [feIcon, _react.default.createElement(_react.Fragment, {
    key: "children"
  }, children)];
  if (iconPosition === 'right') output = [_react.default.createElement(_react.Fragment, {
    key: "children"
  }, children), feIcon];
  return output;
};

exports.renderIcon = renderIcon;

var FeButton = function FeButton(props) {
  var active = props.active,
      background = props.background,
      children = props.children,
      className = props.className,
      disabled = props.disabled,
      icon = props.icon,
      iconFamily = props.iconFamily,
      iconPosition = props.iconPosition,
      size = props.size,
      feStyle = props.feStyle,
      buttonProps = _objectWithoutProperties(props, ["active", "background", "children", "className", "disabled", "icon", "iconFamily", "iconPosition", "size", "feStyle"]);

  var buttonClass = (0, _classnames.default)('fe-btn', "fe-btn--".concat(feStyle), "fe-btn--".concat(size), {
    'fe-btn--link-light': feStyle === 'link-secondary' && background === 'light',
    active: active,
    disabled: disabled
  }, className);
  return _react.default.createElement("button", _extends({
    type: "button"
  }, buttonProps, {
    className: buttonClass,
    disabled: disabled
  }), icon ? renderIcon(props) : children);
};

FeButton.defaultProps = {
  active: false,
  background: 'default',
  disabled: false,
  size: 'md',
  feStyle: 'primary'
};
FeButton.propTypes = {
  /** Set true/false to change button active state*/
  active: _propTypes.default.bool,

  /** Button style, either regular or danger. Default is regular */
  background: _propTypes.default.oneOf(['default', 'light']),

  /** Set true/false to change button disabled state*/
  disabled: _propTypes.default.bool,

  /** If an icon is needed in the button add a font awesome icon name here*/
  icon: _propTypes.default.string,

  /** The icon family for the button icon. Can be regular, solid, light, or brand */
  iconFamily: _propTypes.default.oneOf(['regular', 'solid', 'light', 'brand']),

  /** Position of the optional icon. Use 'only' if there's no text with an icon*/
  iconPosition: _propTypes.default.oneOf(['left', 'right']),

  /** Button size 'xs', 'sm', 'md', or 'lg'. Default is medium */
  size: _propTypes.default.oneOf(['xs', 'sm', 'md', 'lg']),

  /** The button style primary, link, secondary-danger,etc. Default is primary */
  feStyle: _propTypes.default.oneOf(['primary', 'primary-danger', 'secondary', 'secondary-danger', 'link', 'link-secondary', 'link-danger'])
};
var _default = FeButton;
exports.default = _default;